'use client';
import { CssBaseline } from '@mui/material';
import ReduxProvider from 'src/components/providers/redux';
import { NerdWalletThemeProvider } from 'src/components/providers/theme';
import { PreloadedRootState } from 'src/redux/store';
import { initDDRum } from '../../datadog-rum';
import { initDDLogs } from '../../datadog-logs';
import { AnalyticsProvider } from 'src/components/providers/analytics';
import { ContextData } from '@absmartly/javascript-sdk/types/context';
import { AbSmartlyProvider } from 'src/components/absmartly';
import InstantiateClientSideState from 'src/components/instantiate-client-side-state';

initDDRum();
initDDLogs();

type ProvidersProps = {
  initialReduxState: PreloadedRootState;
  abSmartlyContextData?: ContextData;
  children: React.ReactNode;
};
function Providers({
  children,
  abSmartlyContextData,
  initialReduxState,
}: ProvidersProps) {
  return (
    <ReduxProvider initialReduxState={initialReduxState}>
      <InstantiateClientSideState />
      <AnalyticsProvider>
        {abSmartlyContextData ? (
          <AbSmartlyProvider
            contextData={abSmartlyContextData}
            experimentMap={
              new Map(
                abSmartlyContextData.experiments?.map((experiment) => [
                  experiment.name,
                  experiment,
                ])
              )
            }
          >
            <NerdWalletThemeProvider>
              <CssBaseline />
              {children}
            </NerdWalletThemeProvider>
          </AbSmartlyProvider>
        ) : (
          <NerdWalletThemeProvider>
            <CssBaseline />
            {children}
          </NerdWalletThemeProvider>
        )}
      </AnalyticsProvider>
    </ReduxProvider>
  );
}

export default Providers;
